export default {
  title: "Redefinir Senha",
  description: "Crie uma nova senha para sua conta",
  newPassword: "Nova senha",
  confirmPassword: "Confirmar senha",
  submit: "Redefinir Senha",
  processing: "Processando...",
  validatingToken: "Validando sua solicitação...",
  invalidToken: "Link de redefinição inválido",
  tokenExpiredOrInvalid: "O link de redefinição de senha expirou ou é inválido",
  requestNewLink: "Você precisará solicitar um novo link de redefinição de senha",
  backToLogin: "Voltar para o login",
  successTitle: "Senha redefinida com sucesso!",
  successDetail: "Sua senha foi atualizada com sucesso.",
  redirecting: "Redirecionando para a página de login...",
  invalidRequest: "Solicitação inválida. Verifique o link de redefinição e tente novamente.",
  genericError: "Ocorreu um erro ao redefinir sua senha. Tente novamente mais tarde.",
  successMessage: "Sua senha foi redefinida com sucesso. Você será redirecionado para o login.",
  requirements: "Requisitos de senha:",
  reqMinLength: "Pelo menos 8 caracteres",
  reqUppercase: "Pelo menos uma letra maiúscula",
  reqLowercase: "Pelo menos uma letra minúscula",
  reqNumber: "Pelo menos um número",
  reqSpecial: "Pelo menos um caractere especial",
  passwordsDoNotMatch: "As senhas não coincidem",
  passwordsMatch: "As senhas coincidem",
  
  // Novas mensagens específicas para diferentes erros de token
  tokenExpired: "O link de redefinição de senha expirou",
  tokenExpiredDescription: "O tempo limite para usar este link de redefinição de senha acabou. Por favor, solicite um novo link.",
  tokenAlreadyUsed: "Este link já foi utilizado",
  tokenAlreadyUsedDescription: "Este link de redefinição já foi utilizado anteriormente para redefinir uma senha. Por motivos de segurança, cada link pode ser usado apenas uma vez.",
  invalidTokenDescription: "O link de redefinição que você está tentando usar é inválido. Verifique se copiou corretamente o link do email ou solicite um novo.",
  errorResetting: "Erro ao redefinir senha",
  sessionCleared: "Sessão limpa por segurança"
} as const;
